/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import styles from './styles.module.scss'
import { useDispatch } from 'react-redux'
import { addNewOperation, updateOperation } from '../../../../../Redux/operations/operationsSlice'
import { arrayOfColors } from './helper'
import { useTranslation } from 'react-i18next'

const index = ({ close, data }) => {
  const { t } = useTranslation() || ((text) => text)

  const { id, price, op_name, unitary, category, color } = data || {
    id: null,
    price: 0,
    op_name: '',
    unitary: false,
    category: 'stomatology',
    color: ''
  }
  const [isUnitary, setUnitary] = useState(unitary)
  const [categoryVal, setCategory] = useState(category)
  const [colorState, setColor] = useState(color)
  const dispatch = useDispatch()

  const submitData = (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    const formObject = {
      op_name: formData.get('op_name'),
      price: Number(formData.get('price')),
      category: categoryVal,
      unitary: isUnitary,
      color: colorState || arrayOfColors[0],
      close
    }
    if (!data) {
      dispatch(addNewOperation(formObject))
    } else {
      dispatch(
        updateOperation({
          ...formObject,
          id
        })
      )
    }
  }

  const changeColor = (e, color) => {
    e.preventDefault()
    e.stopPropagation()
    setColor(color)
  }

  console.log('isUnitary', isUnitary)

  return (
    <div className={styles.popup_wrapper}>
      <div className={styles.form_header}>
        <h2 className={styles.header_text}>{t('ADD_NEW_OPERATION')}</h2>
        <button className={styles.close_btn} onClick={close}>
          ✖
        </button>
      </div>
      <form className={styles.popup_from_container} onSubmit={submitData}>
        <div className={styles.form_entry}>
          <label className={styles.entry_label} htmlFor='op_name'>
            {t('operation_name')}
          </label>
          <input defaultValue={op_name} className={styles.entry_input} required type='text' id='op_name' name='op_name' />
          <div className={styles.radio_container}>
            <div className={styles.radio_input_container}>
              <input
                checked={categoryVal === 'stomatology'}
                onChange={() => setCategory('stomatology')}
                className={styles.entry_input}
                type='radio'
                id='stomatology'
                name='stomatology'
              />
              <label className={styles.entry_label} htmlFor='stomatology'>
                Stomatology
              </label>
            </div>
            <div className={styles.radio_input_container}>
              <input
                checked={categoryVal === 'pulmonology'}
                onChange={() => setCategory('pulmonology')}
                className={styles.entry_input}
                type='radio'
                id='pulmonology'
                name='pulmonology'
              />
              <label className={styles.entry_label} htmlFor='pulmonology'>
                Pulmonology
              </label>
            </div>
          </div>
        </div>
        <div className={styles.form_entry}>
          <label className={styles.entry_label} htmlFor='price'>
            {t('Price')}
          </label>
          <input defaultValue={price} className={styles.entry_input} required type='number' step='0.01' id='price' name='price' />
          <div className={styles.radio_container}>
            <div className={styles.radio_input_container}>
              <input
                checked={isUnitary}
                onChange={() => setUnitary(true)}
                className={styles.entry_input}
                type='radio'
                id='unitary_price'
                name='unitary_price'
              />
              <label className={styles.entry_label} htmlFor='unitary_price'>
                {t('unitary')}
              </label>
            </div>
            <div className={styles.radio_input_container}>
              <input
                checked={!isUnitary}
                onChange={() => setUnitary(false)}
                className={styles.entry_input}
                type='radio'
                id='full'
                name='full'
              />
              <label className={styles.entry_label} htmlFor='full'>
                {t('full')}
              </label>
            </div>
          </div>
        </div>
        <div className={styles.form_entry}>
          <label className={styles.entry_label} htmlFor='price'>
            {t('apt_color')}
          </label>
          <ul className={styles.colors_list_container}>
            {arrayOfColors.map((colorVal, index) => (
              <li key={index} className={styles.color_item}>
                <button
                  type='button'
                  onClick={(e) => changeColor(e, colorVal)}
                  className={`${styles.color_button} ${colorState === colorVal ? styles.active_color : ''}`}
                  style={{ backgroundColor: colorVal }}
                />
              </li>
            ))}
          </ul>
        </div>
        <div className={styles.form_entry}>
          <button className={styles.submit_button} type='submit'>
            {data ? t('save') : t('add')}
          </button>
        </div>
      </form>
    </div>
  )
}
export default index
